module.exports = __webpack_public_path__ + "static/media/dragomalfoy.3414ee69.jpeg";